exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".streams .stream[data-v-7bb16207]{display:flex;width:100%;border:1px solid #d3d3d3;padding:1em;margin:1em 0;border-radius:3px}.streams a[data-v-7bb16207]{display:flex;flex-direction:row;text-decoration:none;color:#636b6f}.streams picture[data-v-7bb16207]{padding-right:10px}.streams .info[data-v-7bb16207]{font-size:1em;flex:1 1 auto}@media (max-width:800px){.streams .info[data-v-7bb16207]{font-size:.8em}}.streams .name[data-v-7bb16207]{display:block;font-weight:700;font-size:3em}@media (max-width:1000px){.streams .name[data-v-7bb16207]{font-size:2em}}@media (max-width:800px){.streams .name[data-v-7bb16207]{font-size:1.5em}}", ""]);

// exports
